import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class saveTransactionCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(t, id_bank_account:string, conciliation_state?:string, asiento?:Number): Promise<any> {
    for (var c in t.contrapartida){
      if (typeof(t.contrapartida[c].account) === 'object'){
        t.contrapartida[c] = t.contrapartida[c].account
      }
    }
    let args = {
      id: t.id,
      contrapartida: t.contrapartida,
      concept: t.concept,
      id_bank_account: id_bank_account,
      balance: t.balance_after_transaction,
      department_id: t.department_id || ''
    }
    if (conciliation_state && asiento) {
      args['conciliation_state'] = conciliation_state
      args['asiento'] = asiento
    }
    this.frontend.change_loading_save_transaction(t.id, true)
    await this.dispatcher.dispatch('save.transaction', args)
    this.frontend.change_loading_save_transaction(t.id, false)
    this.frontend.totalEffects = structuredClone(this.frontend.totalEffectsCopy)
  }
}